import { createSlice } from "@reduxjs/toolkit";

const initialorganizationState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  organizationForEdit: undefined,
  lastError: null,
  // ! PROGRAM, DONOR, DONATION COUNT
  donorCount: 0,
  donationCount: 0,
  programCount: 0,
  // ? ORGANIZATION FILES
  organizationFiles: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminOrganizationSlice = createSlice({
  name: "organization",
  initialState: initialorganizationState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getorganizationById
    organizationFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.organizationForEdit = action.payload.organizationForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
      state.donationAmountSum = action.payload.donationAmountSum;
    },
    // findorganization
    organizationsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    organizationReload: (state, action) => {
      state.entities = [];
      state.totalCount = 0;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    organizationFiles: (state, action) => {
      state.organizationFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
